import { OSId } from '@ps/platform-message-framework/common/OSId';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { CasinoFilter } from '@swf/casino';
import { Vary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import StarsNav, { Variant as NavVariant } from '@swf/components/StarsNavigation/StarsNavigation';
import { getActive } from '@swf/core/models/casino/utils';
import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';
import { getStyle } from '@swf/core/utils/casino';

import styles from './CasinoSecondaryNavigation.scss';
import { secondaryNavigationWidgetModel, useSecondaryNavWidgetModel, userMatcher } from './model';

const CasinoSecondaryNavigation: WidgetFC = () => {
  const { widgetConfig, widgetSelect } = useSecondaryNavWidgetModel();

  const { sticky, navigation, layout } = widgetConfig;
  // remove stickiness due to chrome v114 bug on Android
  // https://bugs.chromium.org/p/chromium/issues/detail?id=1451203
  // https://bugs.chromium.org/p/chromium/issues/detail?id=1459053
  const isSticky = useSelector(select.device.getOS) === OSId.ANDRO_ID ? false : sticky;
  const items = navigation.map((block) => ({ text: block.link.title, url: block.link.href }));

  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const pathname: string = useSelector(select.location.getPathname);
  const data = useSelector(widgetSelect.get);

  const [active] = getActive(pathname, items);

  const filtered = items.filter((item) => {
    const [toCheck] = item?.url?.match(userMatcher) || [];
    // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
    return item.text && (!toCheck || (isAuthenticated && data && data[toCheck]?.length > 2));
  });

  return (
    <div className={classNames(styles.backgroundWrapper, { [styles.sticky]: isSticky })}>
      <div className={styles.container} style={getStyle(layout)}>
        <StarsNav variant={NavVariant.Transparent}>
          <Vary by={[]} />
          {filtered.map(({ text, url }, index) => (
            <CasinoFilter
              key={index}
              href={url}
              active={url === active}
              translation={{ defaultMessage: text, track: text, id: text }}
            />
          ))}
        </StarsNav>
      </div>
    </div>
  );
};

CasinoSecondaryNavigation.model = secondaryNavigationWidgetModel;

export default CasinoSecondaryNavigation;
